import { Controller } from 'stimulus'
import { setPickerValue } from '../lib/date_range_picker'

export default class extends Controller {
    static targets = ['form']

    connect() {
        this.bindEvents()
    }

    bindEvents() {
        for (const input of this.formTarget.querySelectorAll('input')) {
            input.addEventListener('keyup', () => { this.search() })

            // Use jQuery caller to be sure the event is called.
            $(input).on('apply.daterangepicker', (event, picker) => {
                setPickerValue(picker)
                this.search()
            })
        }

        for (const select of this.formTarget.querySelectorAll('select')) {
            // Use jQuery caller to be sure the event is called.
            $(select).on('change', () => { this.search() })
        }
    }

    search() {
        this.formTarget.requestSubmit()

        const formData = new FormData(this.formTarget)
        const queryParams = new URLSearchParams(formData).toString()

        window.history.replaceState(null, null, '?' + decodeURI(queryParams))
    }
}
